<template>
  <v-navigation-drawer permanent dark clipped class="hidden-sm-and-down" width="200">
    <v-divider></v-divider>
    <v-list dense class="pt-0">
      <v-list-tile v-for="item in items" :key="item.title" @click="$router.push(item.path)">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    data () {
      return {
        items: [
          { title: 'Dashboard', icon: 'dashboard', path: '/admin' },
          { title: 'About', icon: 'dashboard', path: '/admin/about' },
          { title: 'Design', icon: 'dashboard', path: '/admin/design' },
          { title: 'Experience', icon: 'dashboard', path: '/admin/experience' },
          { title: 'Projects', icon: 'dashboard', path: '/admin/project' },
          { title: 'Slider Images', icon: 'dashboard', path: '/admin/slider-images' },
          { title: 'Image Gallery', icon: 'dashboard', path: '/admin/image-gallery' },
          { title: 'Company Contact', icon: 'dashboard', path: '/admin/company-contact' },
          { title: 'Social Links', icon: 'dashboard', path: '/admin/social-links' },
          { title: 'Video Gallery', icon: 'dashboard', path: '/admin/video-gallery' }
        ],
        right: null
      }
    }
  }
</script>

<style scoped>
.navigation-drawer {
  position: fixed;
  top: 48px;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DashBoardNavDrawer.vue